module.exports = "/images/icon_48_rightchev.png?9a5f35f5f15b5c72ddaf297fb841619c";